import { ApiService } from './api.service';
import { Competency, QuestionTypesWithCompetency, CompetencySettingType } from '@/models/competency/competency';
import { QuestionType } from '@/models/evalSetting/question-type';
import { AuthInfo } from '@/models/auth-info';
import { Trend } from '@/models/trend/trend';
import { Destination } from '@/models/jgrow/destination';
import { InterviewNaviCompetency } from '@/models/interview-navi/competency';
import { Language } from '@/models/language';
import { LgatePreLinkage } from '@/models/lgate/lgate-pre-linkage';
import { Empty } from '@/models/core/empty';

class LgateService extends ApiService {
  constructor() {
    super();
  }

  /**
   * L-Gate連携 連携前確認用（生徒一括登録の checkDifferences に近いもの）
   * 差分がレスポンスされる（新規 x件, 更新 x件, 削除 x件）
   */
  requestPreLinkage(): Promise<LgatePreLinkage> {
    return this.post<LgatePreLinkage>(LgatePreLinkage, `/lgate/pre-linkage`, {});
  }

  /**
   * L-Gate連携 連携の実施
   * レスポンスは特になし
   */
  requestLinkage(): Promise<Empty> {
    return this.post(Empty, `/lgate/linkage`, {});
  }
}

export const lgateService = new LgateService();
